import $ from 'jquery'
import { trace } from 'rytm-helpers'

import Controller from "./Controller.js";
// import mainController from './../MainController';

class HomeAboutController extends Controller {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
  }
  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    super.addEventListeners();
    this.startTextRotation();
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    super.removeEventListeners();
    clearInterval(this.interval);
  }
  /**
   * ### OWN ###
   */
  startTextRotation() {
    const container = document.querySelector(this.getContainerSelector());
    const textContainer = container ? container.querySelector('.info-wrapper') : null;
    const list = textContainer ? textContainer.querySelectorAll('p') : [];
    if (list.length > 0) {
      const interval = container.dataset.interval ? parseInt(container.dataset.interval) : 4000;
      list[0].classList.add('active');
      let index = 1;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        if (index >= list.length) {
          index = 0;
        }
        list.forEach((el, i) => {
          if (i === index) {
            el.classList.add('active');
          } else {
            el.classList.remove('active');
          }
        });
        index++;
      }, interval);
    }
  }

}
export default HomeAboutController